<!--
Occupancy section in Library/Study Spaces screen.
Usage: <Occupancy />
@author cm359n
-->
<template>
  <div class="content">
      <div class="occupancyTable">
          <span v-if="spaces.length == 0">We're still checking the study spaces...<br/>
          If you are still seeing this message after 10-15 seconds please go to the App Support menu item and let us know.</span>
          <StudySpace v-for="(space, index) in spaces"
             :firstSpace="index == 0"
             :overrideMsg="space.spaceOverrideMsg"
             :key="`space-${index}-${space.upd}`"
             :occupancyStatus="space.occupancyStatus"
             :name="space.studySpaceName"
             :lastUpdated="space.lastUpdated"
             :openTime="space.openTime"
             :schedule="space.openingHours"
             :closeTime="space.closeTime"
             :facilities="space.facilities"
             :currentlyUsed="space.currentlyUsed" />
      </div>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import axios from 'axios'
import * as lst from '@/components/localStorage.js'

//Components
import StudySpace from '@/components/spaces/StudySpace.vue'

//Composables
import {getLibraryOccupancyStatus} from '@/composables/SpaceCommon.js'
//import SpaceCommon from '@/mixins/SpaceCommon.js'

//Data
let bsh = '07:00'
let beh = '20:00'
let liboverride = ''
let libhrs = lst.getValue('libraryHours')
if (typeof libhrs !== 'undefined') {
  bsh = libhrs.openTime
  beh = libhrs.closeTime
  liboverride = libhrs.altMsg
} else {
  console.log('no default library opening/closing times given: ' + bsh + ' and ' + beh + ' are the defaults')
}

const hour = ref({ start: bsh + ':00', end: beh + ':00' })
const libraryOccupancyStatus = ref(1)
const librarySpacesAvailable = ref('')
const libraryOverrideMsg = ref(liboverride)
const spaces = ref([])
const librarySchedule = ref(null)
const libraryInSpaces = ref(false)
const lastChecked = ref(null)

onMounted(
  () => {
    getStudySpaces()
  }
)

function getLibraryOccupancy () {
  axios.get(process.env.VUE_APP_OCCUPANCY_URL, { withCredentials: false })
    .then(response => {
      // levels from WCSC-864 are 60% and 80% (40% left = busy and 20% left = full)
      let maxOccupancy = response.data.maxOccupancy
      let target = maxOccupancy - response.data.occupancyLevel
      librarySpacesAvailable.value = target

      let occ = getLibraryOccupancyStatus(target, maxOccupancy)
      libraryOccupancyStatus.value = occ['status']
      // this.library = occ['description']
      // TODO library closed?
    })
}

function isLibrary (str) {
  let ret = false
  let s = str.trim()
  // console.log('s = "' + s + '"')
  if (s.toLowerCase() == 'library') {
    ret = true
  }
  return ret
}

function getStudySpaces () {
  axios.get('/timetable/studyspaces/available', { withCredentials: true })
    .then(response => {
      let spaceData = response.data
      let d = new Date()
      // add 'upd' key to each to force it to re-render if we need to insert fake facilities data
      for (let space of spaceData) {
        space.upd = d.getTime()
        if (space.studySpaceName == 'Library' || space.studySpaceName == 'Main Library') {
          space.spaceOverrideMsg = libraryOverrideMsg.value
          // DON'T replace occupancy status with the one from library occupancy feed!
          // it's deprecated
          // space.occupancyStatus = this.libraryOccupancyStatus
          if (typeof space.spaceOverrideMsg !== 'undefined' && space.spaceOverrideMsg != null) {
            console.log('library override msg is ' + space.spaceOverrideMsg)
          }
        }
      }
      spaces.value = spaceData
      lastChecked.value = new Date()

      // and finally sort them on studySpaceName
      spaces.value.sort((a, b) => {
        return b.studySpaceName - a.studySpaceName
      })

      // and check if we need 'fake' static study space features
      checkFeaturesAvailable()
    })
    .catch((error) => {
      console.log(error)
    })
}

function addFacilitiesToSpace (spaceName, facils) {
  let ret = false
  let d = new Date()
  for (let space of spaces.value) {
    if (space.studySpaceName === spaceName) {
      space.facilities = facils
      space.upd = d.getTime()
      // console.log('space "' + space.studySpaceName + '" should be updated with ' + facils)
      ret = true
    }
  }
  if (ret == false) {
    console.log('study space "' + spaceName + "' not found when inserting facilities information")
  }
  return ret
}

function checkFeaturesAvailable () {
  // look at spaces
  let hasFeatures = false
  for (let space of spaces.value) {
    if (typeof space.facilities !== 'undefined') {
      hasFeatures = true
    }
  }

  if (!hasFeatures) {
    console.log('campus card ws has not sent us any facilities information')
  }
}

</script>

<style>

.occupancyTable {
  margin-left: 20px;
  margin-right:10px;
}

.occupancyTable td {
  padding: 5px;
}

.occupancyTable .unused td {
  padding: 5px;
  color: #999;
  font-style: italic;
}
.preamble {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    padding-bottom: 15px;

    color: #828282;
}
.hourlyupdates {
    font-style: italic;
    font-weight: normal;
    font-size: 13px;
    color: #828282;
    padding-bottom: 15px;
}

</style>
